export default __webpack_public_path__ + "static/media/437.263b4385.png";